import {apiService} from "features/jwt/apiService";
import {apiErrorFrom} from "features/errors";
import {ApartmentViewerServiceEndpoints} from "features/apartmentViewer/services/ApartmentViewerService/config";
import {ApiSiteModel} from "features/apartmentViewer/types";
import axios from "axios";

export class ApartmentViewerService {

    public static readonly getApartmentData = async (stageId: string, objectId: string) => {
        const { data, error, endpoint, statusCode, method, transportError } = await apiService.get<ApiSiteModel>(ApartmentViewerServiceEndpoints.getApartmentData(stageId, objectId));

        if(error) {
            throw apiErrorFrom({ error, endpoint, statusCode, method, transportError }, "Kunde inte hämta 360-vy data");
        }

        return data!;
    }

    public static readonly getQHDRFile = async (stageId: string, visuadoApartmentId: string, archetypeName: string, markerId: string, lowRes: boolean = false) => {
        const domain = window.location.protocol + '//' + window.location.hostname;
        const ext = lowRes ? '_lores.qhdr' : '.qhdr';

        const response = await axios.get(`${domain}${ApartmentViewerServiceEndpoints.getQHDRFile(stageId, visuadoApartmentId, archetypeName, markerId, ext)}`, {
            responseType: 'arraybuffer',
        });

        return response.data;
    }
}
